import { TabsGroup } from 'ui/tabsGroup';
import {
  ButtonText,
  StyledNavTabsList,
  StyledNavTrigger,
  StyledGraphContainer,
} from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTime.styles';
import { PerformanceOverTimeLift } from 'modules/intelligentInsights/frequencyOptimization/types';
import { PeformanceGraphTabContent } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeTabContent';
import { RATE } from 'modules/intelligentInsights/constants';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';

export const PERFORMANCE_OVER_TIME_GRAPH = 'performance-over-time-tab-trigger';

export const GraphTabs = () => {
  const { selectedLiftTab, setSelectedLiftTab } = useFroInsightsCoreContext();

  return (
    <StyledGraphContainer>
      <TabsGroup
        value={selectedLiftTab}
        onValueChange={(newTab) => setSelectedLiftTab(newTab as PerformanceOverTimeLift)}
      >
        <StyledNavTabsList>
          <StyledNavTrigger
            data-test={`${PerformanceOverTimeLift.Open}-${PERFORMANCE_OVER_TIME_GRAPH}`}
            key={PerformanceOverTimeLift.Open}
            value={PerformanceOverTimeLift.Open}
          >
            <ButtonText>{`${PerformanceOverTimeLift.Open} ${RATE}`}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${PerformanceOverTimeLift.Click}-${PERFORMANCE_OVER_TIME_GRAPH}`}
            key={PerformanceOverTimeLift.Click}
            value={PerformanceOverTimeLift.Click}
          >
            <ButtonText>{`${PerformanceOverTimeLift.Click} ${RATE}`}</ButtonText>
          </StyledNavTrigger>
          <StyledNavTrigger
            data-test={`${PerformanceOverTimeLift.Unsubscribe}-${PERFORMANCE_OVER_TIME_GRAPH}`}
            key={PerformanceOverTimeLift.Unsubscribe}
            value={PerformanceOverTimeLift.Unsubscribe}
          >
            <ButtonText>{`${PerformanceOverTimeLift.Unsubscribe} ${RATE}`}</ButtonText>
          </StyledNavTrigger>
        </StyledNavTabsList>
        <PeformanceGraphTabContent />
      </TabsGroup>
    </StyledGraphContainer>
  );
};
